export const frontmatter = {
  title: "List your Tokens",
  order: 9,
}

## Launch your Token on Scale.farm!

Scale.farm is a **Community Powered** Decentralized Protocol. We strive to offer the best tokens to our traders as well as provide earning opportunities to our loyal Liquidity Providers. We understand that the real success in DeFi comes from serving the community with useful features that make their lives better!

A big part of this community is the exciting projects that launch their unique tokens on-chain. We welcome all projects to list their Tokens on Scale.farm and make the best use of all our amazing features!

## Getting Listed

As we offer a Decentralized Protocol, anyone can list their Tokens permissionlessly on Scale.farm on their own!

### Creating a new pool

Simply go to the [Create Liquidity Pool](/liquidity/create) page to create a Liquidity pool for your token to enable trading for that pair!

### Special tokens

We support all sorts of tokens, be it simple ERC20 or exotic assets with transfer-taxes, Rebases, auto-LPs, Reflection, etc. Follow the guide below:

> [Learn how to list special tokens](./fee-on-transfer-tokens)

Please feel free to [contact us](/docs/team) if you have more questions!

### Trading custom tokens

Simply enter the address of the token you want to trade on our [Swap](/swap) page. You can save any token's address on the Swap page with our 'Local Assets' feature!

## Additional Services

For projects looking for more support, we offer additional services:

- **[Whitelisting](/docs/list-your-token/whitelisting)** - Bespoke services for established projects that meet our whitelisting guidelines
- **[Launchpad](/docs/list-your-token/launchpad)** - Tailored launchpad service for upcoming projects
